import { cdnImage } from "@/lib/images";

export const SITE_URL = "https://www.thebyteline.com";

interface ArticleLike {
  id: string;
  slug?: string | null;
}

/** In-app path for an article. Falls back to the id (the route redirects to the slug). */
export const articlePath = (article: ArticleLike): string =>
  `/article/${article.slug || article.id}`;

export const articleUrl = (article: ArticleLike): string => `${SITE_URL}${articlePath(article)}`;

/** A share-sized (1200x630) rendition of the article photo for og:image. */
export const shareImage = (imageUrl?: string | null): string | null => {
  if (!imageUrl) return null;
  const proxied = cdnImage(imageUrl, { width: 1200, height: 630, fit: "cover", format: "jpg", quality: 80 });
  if (!proxied) return null;
  return proxied.startsWith("http") ? proxied : `${SITE_URL}${proxied}`;
};

/** True when the value looks like a UUID rather than a slug. */
export const isUuid = (value?: string | null): boolean =>
  !!value && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value);
